import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/utilities.scss'
import * as Api from './utils/api.js' // 1、引入app.js
import * as Url from "./utils/Url.js";
Vue.prototype.$api = Api //  2、挂载全局

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'
import StorageUtils from './utils/StorageUtils.js'
import VueMeta from 'vue-meta'
import tracker from './utils/tracker'
import TwitterTrackPlugin from './utils/twitterTrack.js' // 重命名以明确是插件
import use from './utils/use.js'
Vue.prototype.$use = use;
Vue.prototype.$storag = StorageUtils;
Vue.prototype.$track = tracker;
if(Url.HOST=='https://api.lky7bet.com'){
  Vue.prototype.$shareUrl = 'https://www.lky7bet.com/pc'
}else {
  Vue.prototype.$shareUrl = 'https://www.lky7game.com/pc'

}

// 引入大转盘插件
import VueLuckyCanvas from '@lucky-canvas/vue'

// 使用插件 - 正确注册 Twitter 跟踪
Vue.use(TwitterTrackPlugin, {
  eventId: 'tw-qhx3x-qn85v' // 可配置的事件 ID
})
Vue.use(VueMeta, {
  keyName: 'metaInfo', // 自定义 meta 信息的属性名
  attribute: 'data-vue-meta', // 自定义属性
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid'
})

Vue.use(VueLuckyCanvas)
Vue.use(ElementUI, {
	locale
});

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')